<template>
  <div class="v-listing-options-loading" />
</template>

<script>
export default {
  name: "VListingOptionsLoading"
};
</script>
